document.addEventListener('DOMContentLoaded', function() {
    const contactForm = document.querySelector('section .container form');
    
    if (contactForm && typeof ajax_object !== 'undefined') {
        contactForm.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const formData = new FormData();
            formData.append('action', 'submit_contact_form');
            const nameField = contactForm.querySelector('input[placeholder="Name"]');
            const companyField = contactForm.querySelector('input[placeholder="Company"]');
            const emailField = contactForm.querySelector('input[placeholder="Email"]');
            const messageField = contactForm.querySelector('textarea[placeholder="Message"]');
            
            if (!nameField || !emailField || !messageField) {
                showError('Form fields not found');
                return;
            }
            
            formData.append('name', nameField.value.trim());
            formData.append('company', companyField ? companyField.value.trim() : '');
            formData.append('email', emailField.value.trim());
            formData.append('message', messageField.value.trim());
            formData.append('nonce', ajax_object.nonce);
            
            fetch(ajax_object.ajax_url, {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    contactForm.innerHTML = '<div class="alert alert-success text-center"><h4>Thank you!</h4><p>Your message has been sent successfully. We\'ll get back to you soon.</p></div>';
                } else {
                    showError('Error: ' + (data.data || 'Unknown error'));
                }
            })
            .catch(error => {
                showError('Error submitting form. Please try again.');
            });
        });
    }
    
    function showError(message) {
        // Create or update error message element
        let errorDiv = document.querySelector('.form-error-message');
        if (!errorDiv) {
            errorDiv = document.createElement('div');
            errorDiv.className = 'form-error-message alert alert-danger';
            contactForm.insertBefore(errorDiv, contactForm.firstChild);
        }
        errorDiv.textContent = message;
        errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
});